import forge from 'node-forge';
import hash from 'object-hash';
import buffer from 'buffer/';
import firmafiel from '@gobmx-sfp/firmafiel';
import * as crypto from 'crypto-browserify/index.js';

export const convertToArrayBuffer = (file) => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = (event) => {
      resolve(event.target.result);
    };
    reader.onerror = (err) => {
      reject(err);
    };
    reader.readAsArrayBuffer(file);
  });
};

export const convertToBuffer = async (file) => {
  const arr = await convertToArrayBuffer(file);
  const buff = buffer.Buffer.from(arr);
  return buff;
};

export const signDocument = async (dataToSign) => {
  const { certfile, keyfile, password, document } = dataToSign;
  const c = await convertToBuffer(certfile);
  const k = await convertToBuffer(keyfile);
  const pempublica = firmafiel.certBufferToPem({ derBuffer: c });
  const pemprivada = firmafiel.keyBufferToPem({ derBuffer: k });
  // console.log('pempublica', pempublica)
  // console.log('pemprivada', pemprivada)

  /* const cadena = "DOCSOLUTIONS"; */
  try {
    if (
      firmafiel.validaCertificadosFromPem({
        pempublica: pempublica,
        pemprivada: pemprivada,
        passprivada: password,
      })
    ) {
      const cert = firmafiel.pemToForgeCert({ pem: pempublica });

      const today = new Date().getTime();
      const from = cert.validity.notBefore.getTime();
      const to = cert.validity.notAfter.getTime();

      if (today < from || today > to) {
        throw new Error('El certificado ha expirado');
      }

      const privateKey = firmafiel.pemToForgeKey({
        pemkey: pemprivada,
        pass: password,
      });
      const p7 = forge.pkcs7.createSignedData();
      p7.content = forge.util.createBuffer(forge.util.decode64(document));
      p7.addCertificate(cert);
      p7.addSigner({
        key: privateKey,
        certificate: cert,
        digestAlgorithm: forge.pki.oids.sha256,
      });
      p7.sign({ detached: true }); //es importante poner {detached:true} porque si no , se anexan los datos sin encriptar es decir cualquiera con la firma puede ver los datos firmados
      const pem = forge.pkcs7.messageToPem(p7);

      return { status: 'ok', firma: pem };
    }
  } catch (e) {
    console.log(e);
    return { status: 'error en el firmado:' + e.stack };
  }
};

export const extractSignatureFromPem = (dataToExtract) => {
  const { pemSignature } = dataToExtract;
  try {
    const msg = forge.pkcs7.messageFromPem(pemSignature);
    const sig = msg.rawCapture.signature;
    const signatureb64 = forge.util.encode64(sig);
    return signatureb64;
  } catch (err) {
    console.log(err);
    throw new Error('Error al extraer la firma.');
  }
};

export const verifySignature = async ({ pemSignature, certfile, document }) => {
  const c = await convertToBuffer(certfile);
  const pempublica = firmafiel.certBufferToPem({ derBuffer: c });
  const msg = forge.pkcs7.messageFromPem(pemSignature);
  const sig = msg.rawCapture.signature;
  const certfirmado = msg.certificates[0];
  const certpublico = forge.pki.certificateFromPem(pempublica);
  const algo1 = hash(certfirmado);
  const algo2 = hash(certpublico);
  if (algo1 != algo2) {
    throw new Error('El certificado del firmado no es el mismo que el certificado proporcionado');
  }
  const buf = buffer.Buffer.from(document, 'binary');
  const verifier = crypto.createVerify('RSA-SHA256');
  verifier.update(buf);
  const verified = verifier.verify(forge.pki.certificateToPem(certpublico), sig, 'binary');
  console.log('Verificado', verified);
  return verified;
};

export const toBase64 = (file) =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = (error) => reject(error);
  });
